import request from "../base-request";

export interface IFeedbackCsvResponse {
	jobId: string;
}

export type FeedbackCsvQueryParams = {
	"sort-by": string;
	subject: string;
	author: string;
	"request-response": string;
	"start-date": string;
	"end-date": string;
	view: string;
	feedback_subject: string;
	hashtags: string;
};

export type CompanyFeedbackCsvQueryParams = FeedbackCsvQueryParams & {
	categories: string[];
	shared_with: string;
	complete_date_start: string;
	complete_date_end: string;
	page: string;
};

export const fetchCompanyFeedbackCsv = async (
	query: Partial<CompanyFeedbackCsvQueryParams>
): Promise<IFeedbackCsvResponse> => {
	const params = new URLSearchParams();

	Object.entries(query).forEach(([key, value]) => {
		params.append(key, value);
	});

	const url = `/company/feedback-report.csv?${params.toString()}`;

	const [data] = await request<IFeedbackCsvResponse>(url);

	const jobId = data.jobId;

	return { jobId };
};

declare interface IFeedbackResponse {
	_id: string;
	author_id: string;
	author_object: any;
	categories?: Array<string>;
	company: string;
	deleted?: boolean;
	content?: string;
	feedback_message?: string;
	join_fields?: any;
	last_updated: string;
	shared_with: string;
	subject_ids: Array<string>;
	subjects_list?: Array<any>;
	feedback_request: any;
}

/**
 * Fetches a single Feedback by id
 */
export const fetchFeedbackByID = async (feedbackID: string) => {
	const [data] = await request<IFeedbackResponse>(`/api/v0.1/feedback/${feedbackID}/`);

	return data;
};

export const createFeedback = async (props: {
	aboutList: string[];
	content: string;
	feedback_message: string;
	shareWith: string;
	feedbackRequest?: string;
}) => {
	const [data] = await request<{ feedback_id: string }>(`/api/v0.1/feedback/`, {
		method: "POST",
		body: JSON.stringify(props),
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data;
};

export const updateFeedback = async (props: {
	id?: string;
	aboutList: string[];
	content: string;
	feedback_message: string;
	shareWith: string;
	feedbackRequest?: string;
}) => {
	const [data] = await request<{ feedback_id: string }>(`/api/v0.1/feedback/${props.id}/`, {
		method: "POST",
		body: JSON.stringify(props),
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data;
};

export const fetchHashtags = async () => {
	const [data] = await request<{ hashtags: string[] }>(`/api/v0.1/feedback-hashtags/`);

	return data?.hashtags || [];
};

export const updateFeedbackRequest = async (props: { id?: string; message?: string }) => {
	const [data] = await request<{ feedback_id: string }>(`/api/feedback-request/edit/${props.id}/`, {
		method: "POST",
		body: JSON.stringify({ message: props.message || "" }),
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data;
};

export const createFeedbackRequest = async (props: { requestedTo: string[]; message?: string }) => {
	const [data] = await request<{ feedback_id: string }>(`/api/feedback-request/`, {
		method: "POST",
		body: JSON.stringify({ message: props.message || "", requestedTo: props.requestedTo || [] }),
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data;
};

/**
 * Fetches a single Feedback by id
 */
export const fetchFeedbackRequestValid = async (requestedTo: string[] = []) => {
	const [data] = await request<{ is_allowed: boolean }>(`/api/feedback-request/check/`, {
		method: "POST",
		body: JSON.stringify({ requestedTo }),
		headers: {
			"Content-Type": "application/json",
		},
	});

	return data;
};
